module.exports = __webpack_public_path__ + "img/site-cedis-gdl.1cf1ca93.jpg";